export default __webpack_public_path__ + "static/Mobile-Device-Management-d81ba2b33c7f10fc1376a40bc1446fdf.webp";